import { motion } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Kinetic line-by-line masked reveal for headings.
// inView=true → reveal on scroll; inView=false → reveal on mount (hero).
export const KineticHeading = ({ lines, className = "", delay = 0, inView = false }) => {
  const anim = inView
    ? { whileInView: { y: 0 }, viewport: { once: true, margin: "-40px" } }
    : { animate: { y: 0 } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            {...anim}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
